
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	import Message from '@/components/message.vue';
  import {
    financecontractInvoiceDetail,
    financedeleteServiceContractBill
  } from "@/api/finance"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
			'slz-message': Message,
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private pageSize = 10
    private pageNo = 1
    private total = 0
    private rowmsg:any = {}
    private delShow = false

    private mounted () {
      this.gettablelist()
    }


    private toDel(row){
      this.rowmsg = row
      this.delShow = true
    }
    private async confirmDel(){
      try{
        let res = await financedeleteServiceContractBill({FinanceOrderSettleRecordId:this.rowmsg.Id})
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private exportFile(){
      let url = location.origin + '/pc/finance/contractInvoiceDetailExport'
      url += '?ContractType=1'
      url += '&InvoiceState=' + this.$route.query.InvoiceState
      url += '&BillNo=' + this.keywords
      url += '&IdList=' + this.$route.query.Ids
      url += '&ProviderId=' + this.$route.query.Id
      window.open(url)
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private clearSearch(){
      this.pageNo = 1
      this.keywords = ''
      this.gettablelist()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true  
        let res = await financecontractInvoiceDetail({
          ContractType:1,
          InvoiceState:this.$route.query.InvoiceState,
          ProviderId:this.$route.query.Id,
          BillNo:this.keywords,
          IdList:this.$route.query.Ids,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
